import i18n from '@/i18n';

export const getTranslate = (translatePath: string): string => {
  return String(i18n.t(translatePath));
};

// TODO: Доделать функцию перевода со значением
export const getTranslateWithValue = (translatePath: string, value: any): string => {
  return String(i18n.t(translatePath, value));
};
